import { useCallback, useContext, useSyncExternalStore } from 'react';
import { DiffitUserContext } from '../contexts/DiffitUserContext';

// Admin-only debug mode (toggled from the avatar menu). Per browser, so it
// survives reloads; the change event keeps every mounted reader in sync.
const STORAGE_KEY = 'diffit_debug_mode';
const CHANGE_EVENT = 'diffit-debug-mode-change';

function read() {
  try {
    return localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

function subscribe(callback) {
  window.addEventListener(CHANGE_EVENT, callback);
  window.addEventListener('storage', callback);
  return () => {
    window.removeEventListener(CHANGE_EVENT, callback);
    window.removeEventListener('storage', callback);
  };
}

/** @returns {[boolean, (on: boolean) => void]} Always false for non-admins. */
export function useDebugMode() {
  const { diffitUser } = useContext(DiffitUserContext);
  const stored = useSyncExternalStore(subscribe, read, () => false);
  const setDebugMode = useCallback((on) => {
    try {
      if (on) localStorage.setItem(STORAGE_KEY, '1');
      else localStorage.removeItem(STORAGE_KEY);
    } catch {
      // Storage unavailable — debug mode just won't persist.
    }
    window.dispatchEvent(new Event(CHANGE_EVENT));
  }, []);
  return [!!diffitUser?.is_diffit_admin && stored, setDebugMode];
}
